import { render, staticRenderFns } from "./Despacho.vue?vue&type=template&id=a25f8764&scoped=true&"
import script from "./Despacho.vue?vue&type=script&lang=js&"
export * from "./Despacho.vue?vue&type=script&lang=js&"
import style0 from "./Despacho.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Despacho.vue?vue&type=style&index=1&id=a25f8764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25f8764",
  null
  
)

export default component.exports